import NewsTipStatusSelect from './NewsTipStatusSelect'

export default NewsTipStatusSelect
